import { render } from "./CornerstoneTest.vue?vue&type=template&id=24115ff2&scoped=true"
import script from "./CornerstoneTest.js?vue&type=script&lang=js&external"
export * from "./CornerstoneTest.js?vue&type=script&lang=js&external"

import "./CornerstoneTest.vue?vue&type=style&index=0&id=24115ff2&lang=css"
import "./CornerstoneTest.vue?vue&type=style&index=1&id=24115ff2&scoped=true&lang=css"
import "./CornerstoneTest.vue?vue&type=style&index=2&id=24115ff2&lang=css"
import "./CornerstoneTest.vue?vue&type=style&index=3&id=24115ff2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24115ff2"]])

export default __exports__